import { ScheduleGridHeaderCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";
import injectStores from "components/RootStore/injectStores";
import RootStore from "stores/RootStore";
import type { RouterStore } from "stores/RouterStore";
import Box from "@mui/material/Box";
import DepartmentProductionScheduleStore from "../DepartmentProductionScheduleStore";

interface DepartmentProductionScheduleRightHeaderCellProps
  extends ScheduleGridHeaderCellProps {
  currentHeader: {
    title: string;
    departmentId?: string;
    formId?: string;
  };
  rootStore?: RootStore;
  routerStore?: RouterStore;
}

const DepartmentProductionScheduleRightHeaderCell = injectStores(
  (props: DepartmentProductionScheduleRightHeaderCellProps) => {
    const { currentHeader, rootStore, routerStore } = props;
    const departmentProductionScheduleStore =
      rootStore?.departmentProductionScheduleStore as DepartmentProductionScheduleStore;

    const viewMode = departmentProductionScheduleStore?.viewMode || "byDepartment";
    const prefix = viewMode === "byDepartment" ? "Dept" : "Form";

    // Get unscheduled count for this department
    const departmentId = currentHeader?.departmentId;
    const unscheduledCount = departmentId
      ? departmentProductionScheduleStore?.getUnscheduledCountFor(departmentId)
      : 0;

    const handleUnscheduledClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      if (departmentId) {
        routerStore?.openDialog({
          dialogName: "unscheduledItems",
          dialogContext: departmentId,
        });
      }
    };

    return (
      <div
        style={{
          ...props.style,
          ...props.styles,
          border: "1px solid #eee",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 8px",
          fontSize: "14px",
          whiteSpace: "normal",
          lineHeight: "1.3",
        }}
        title={`${prefix}: ${currentHeader?.title}`}
      >
        <b>
          {prefix}: {currentHeader?.title}
        </b>

        {unscheduledCount > 0 && (
          <Box
            onClick={handleUnscheduledClick}
            sx={{
              backgroundColor: "#ff9800",
              color: "white",
              borderRadius: "12px",
              padding: "2px 8px",
              fontSize: "11px",
              fontWeight: "bold",
              cursor: "pointer",
              marginLeft: "8px",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "#f57c00",
              },
            }}
          >
            {unscheduledCount} to schedule
          </Box>
        )}
      </div>
    );
  }
);

export default DepartmentProductionScheduleRightHeaderCell;
